import { Reveal, Countdown } from "@/components/bits";
import { openCalendlyPopup } from "@/components/Calendly";
import { ArrowRight, CalendarDays, MessageCircle } from "lucide-react";

export default function Postulacion() {
  return (
    <section id="postulacion" data-testid="postulacion-section" className="bg-ink py-20 sm:py-28 lg:py-36">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center">
          <p className="flex items-center justify-center gap-4 text-[11px] font-medium uppercase tracking-[0.3em] text-gold">
            <span className="h-px w-10 bg-gold/50" /> Cómo sumarte <span className="h-px w-10 bg-gold/50" />
          </p>
          <h2 className="mt-8 font-serif text-3xl leading-[1.12] tracking-tight text-cream sm:text-4xl lg:text-5xl">
            ¿Cómo <span className="font-semibold not-italic text-gold">sumarte?</span>
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-sm font-light leading-relaxed text-ash sm:text-base">
            Tenés dos opciones:
          </p>
          <p
            data-testid="postulacion-cupos-badge"
            className="mt-8 inline-flex items-center gap-3 border border-crimson-light/50 bg-crimson/15 px-4 py-2.5"
          >
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-crimson-light opacity-75" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-crimson-light" />
            </span>
            <span className="text-[11px] font-medium uppercase tracking-[0.25em] text-cream">
              Ya somos 5 · Quedan 3 lugares
            </span>
          </p>
        </Reveal>

        <div className="mx-auto mt-16 grid max-w-5xl grid-cols-1 gap-8 md:grid-cols-2">
          <Reveal>
            <div
              data-testid="sumarte-pago-card"
              className="flex h-full flex-col border border-crimson-light/60 bg-coal p-10"
            >
              <p className="text-[11px] font-medium uppercase tracking-[0.3em] text-gold">Pago directo</p>
              <h3 className="mt-4 font-serif text-2xl tracking-tight text-cream sm:text-3xl">Confirmá tu cupo</h3>
              <p className="mt-4 text-sm font-light leading-relaxed text-ash">
                Asegurá tu lugar en la cohorte pagando ahora:
              </p>
              <div className="mt-8 space-y-4">
                <a
                  href="https://mpago.la/1WZTBSS"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="sumarte-pago-full-button"
                  className="flex items-center justify-center gap-2 bg-crimson py-4 text-[11px] font-medium uppercase tracking-[0.22em] text-cream transition-colors duration-300 hover:bg-crimson-light"
                >
                  Pago full · AR$ 340.000 <ArrowRight size={14} />
                </a>
                <a
                  href="https://mpago.la/2MT5Yen"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="sumarte-pago-cuotas-button"
                  className="flex items-center justify-center gap-2 border border-cream/25 py-4 text-[11px] font-medium uppercase tracking-[0.22em] text-cream transition-colors duration-300 hover:border-gold hover:text-gold"
                >
                  2 cuotas de AR$ 185.000 · Oferta especial <ArrowRight size={14} />
                </a>
              </div>
              <p className="mt-auto pt-8 text-xs font-light leading-relaxed text-ash/80">
                La oferta termina el 3 de septiembre para quienes confirmen su participación.
              </p>
              <div className="mt-4">
                <Countdown compact />
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.12}>
            <div
              data-testid="sumarte-postulacion-card"
              className="flex h-full flex-col border border-cream/15 bg-coal p-10"
            >
              <p className="text-[11px] font-medium uppercase tracking-[0.3em] text-gold">Por postulación</p>
              <h3 className="mt-4 font-serif text-2xl tracking-tight text-cream sm:text-3xl">Sesión de Claridad</h3>
              <p className="mt-4 text-sm font-light leading-relaxed text-ash">
                ¿Tenés dudas de si Bestias de la literatura argentina es para vos? ¿Querés saber si el Club sería una
                mejor opción en tu caso? Conversemos en una sesión de Claridad de 20 minutos.
              </p>
              <div className="mt-auto pt-8">
                <button
                  onClick={openCalendlyPopup}
                  data-testid="postulacion-calendly-button"
                  className="flex w-full items-center justify-center gap-3 bg-crimson py-4 text-[11px] font-medium uppercase tracking-[0.22em] text-cream transition-colors duration-300 hover:bg-crimson-light"
                >
                  <CalendarDays size={16} /> Agendar ahora
                </button>
              </div>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.15} className="mt-14 text-center">
          <p className="text-sm font-light text-ash">
            ¿Preferís escribirme directo?{" "}
            <a
              href="https://wa.me/5491165168266"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="postulacion-whatsapp-link"
              className="inline-flex items-center gap-1.5 text-gold transition-colors hover:text-cream"
            >
              <MessageCircle size={14} /> Enviame un WhatsApp
            </a>
          </p>
        </Reveal>
      </div>
    </section>
  );
}
